import { useState, FormEvent } from 'react';

const FORM_URL = "https://readdy.ai/api/form/d7lr0klbmnmv4i2ujce0";

export default function NewsletterSection() {
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [email, setEmail] = useState('');

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!email) return;
    setStatus('loading');
    try {
      const body = new URLSearchParams({ email });
      const res = await fetch(FORM_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString(),
      });
      if (res.ok) {
        setStatus('success');
        setEmail('');
      } else {
        setStatus('error');
      }
    } catch {
      setStatus('error');
    }
  };

  return (
    <section className="py-20 bg-white border-t border-gray-100">
      <div className="max-w-2xl mx-auto px-6 text-center">
        <div className="w-12 h-12 flex items-center justify-center mx-auto rounded-2xl bg-green-100 mb-5">
          <i className="ri-mail-send-line text-green-600 text-xl" />
        </div>
        <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-black text-gray-900 mb-2 uppercase leading-none">
          FIQUE POR DENTRO<br />DAS NOVIDADES
        </h2>
        <p className="text-gray-500 text-sm mb-8">
          Receba em primeira mão lançamentos, promoções e dicas sobre soldagem de geomembrana.
        </p>

        {status === 'success' ? (
          <div className="flex items-center justify-center gap-2 text-green-600 font-black text-sm uppercase">
            <i className="ri-checkbox-circle-line text-xl" />
            Inscrição realizada com sucesso!
          </div>
        ) : (
          <form
            id="newsletter-soldageo"
            data-readdy-form="true"
            className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto"
            onSubmit={handleSubmit}
          >
            <input
              placeholder="seu@email.com.br"
              required
              type="email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="flex-1 border border-gray-200 rounded-full px-5 py-3 text-sm text-gray-800 focus:outline-none focus:ring-2 focus:ring-green-400 focus:border-transparent"
            />
            <button
              type="submit"
              disabled={status === 'loading'}
              className="bg-green-500 hover:bg-green-600 text-white text-sm px-6 py-3 rounded-full transition-all cursor-pointer whitespace-nowrap disabled:opacity-60"
            >
              {status === 'loading' ? 'Enviando...' : 'Inscrever-se'}
            </button>
          </form>
        )}

        {status === 'error' && (
          <p className="mt-3 text-red-500 text-xs">Ocorreu um erro. Tente novamente.</p>
        )}
      </div>
    </section>
  );
}
